import { render, staticRenderFns } from "./raw-ckeditor.vue?vue&type=template&id=720285a6"
import script from "./raw-ckeditor.vue?vue&type=script&lang=js"
export * from "./raw-ckeditor.vue?vue&type=script&lang=js"
import style0 from "./raw-ckeditor.vue?vue&type=style&index=0&id=720285a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports